
export const isSpaceSymbolString = (targetString: string) => {
    const testArray: string[] = targetString.split(regexSpaceSymbolOneMore);
    return testArray.length === 2 && !testArray.join('');
};

const regexSpaceSymbolOneMore = /[\s`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]+/;
